var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBasemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135.59mm",
    height: "103.42mm",
    viewBox: "0 0 135.59 103.42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.14 -126.26)",
    fill: "#34495e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-141.4 228.17-42.736-10.867 0.083-40.309 19.203-0.038 23.394 23.696z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-184.07 169.18 0.018-42.747 42.467 10.328 0.1053 52.746-19.769-19.956z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-133.59 228.15 34.284-8.4687-0.5764-54.82-7.0448-5.4718-26.719 40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-133.3 187.98 24.442-37.309 9.3937 7.3649 1.0159-31.78-35.293 12.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-91.488 219.46 41.985 10.22 0.9566-32.112-20.841 0.042-22.376-26.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-48.563 189.75-0.091-50.626-42.253-12.174-1.4391 36.478 24.794 26.36z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasemap);
export default __webpack_public_path__ + "static/media/basemap.9f5f4d5e2ea692fcc919b6fab5e0f1e7.svg";
export { ForwardRef as ReactComponent };